import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3846bed9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loadout-inventory-item-body" }

import { PropType } from 'vue';
import { InventoryItemOption } from '../../../../ecs/loadout/main';
import InventoryIconComponent from '../../../icon/InventoryIconComponent.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'LoadoutInventoryItemComponent',
  props: {
  item: {
    type: Object as PropType<InventoryItemOption>,
    required: true
  }
},
  setup(__props) {

const prop = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(InventoryIconComponent, _normalizeProps(_guardReactiveProps(prop)), null, 16)
  ]))
}
}

})